export const parseAttributes = (profile, profileId) => (
	profile
     && profile[profileId]
     && profile[profileId].attributes
     && profile[profileId].attributes.length > 0
     && profile[profileId].attributes.reduce((map, obj) => {
     	const key = map[obj.key];
    	const attributeKeys = ['com.cerner.gwx.voyager.profiles.email', 'com.cerner.gwx.voyager.profiles.email.pending'];
    	if (key) {
    		if (Array.isArray(key)) {
    			key.push(obj);
    			map[obj.key] = key;
    		} else {
    			map[obj.key] = [key, obj];
    		}
    	} else if (attributeKeys.includes(obj.key)) {
    		map[obj.key] = [obj];
    	} else {
    		map[obj.key] = obj;
    	}

    	return map;
     }, {})
);

export const profileAttribute = (attributes, key) => (
	attributes[key]
);

export const profileAttributeValue = (attributes, key) => (
	(attributes && attributes[key] && attributes[key].value) || undefined
);

export const profileEmails = (attributes) => (
	(attributes && attributes['com.cerner.gwx.voyager.profiles.email']) || []
);

export const profileName = (attributes, fallback = 'User') => {
	const firstName = profileAttributeValue(attributes, 'com.cerner.gwx.voyager.profiles.first.name');
	const lastName = profileAttributeValue(attributes, 'com.cerner.gwx.voyager.profiles.last.name');
	return firstName || lastName ? `${firstName || ''} ${lastName || ''}` : fallback;
};
